module.exports = __webpack_public_path__ + "fonts/DINPro-Light.acc50e7e.woff2";